module.exports = __webpack_public_path__ + "img/ecosystem_01_solana1.5fff5cfe.png";